import { createApp } from "vue";
import "@/assets/css/common.less";
import routers from "@/router";
import "vant/es/toast/style";
import "vant/es/dialog/style";
import AntdClass from "@/services/AntdClass";
import App from "./app.vue";

const app = createApp(App);
new AntdClass(app);
app.use(routers);
app.mount("#root");
